import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import store from '../store'

import Daily from '../screens/Daily.vue'
import Leaderboard from '../screens/Leaderboard.vue'
import Archive from '../screens/Archive.vue'
import Callback from '../screens/Callback.vue'

/*
	The full boxart route table.

	- `/`               today's puzzle (Daily, no date prop)
	- `/play/:date`     a past day, unranked (Daily with the date prop); kept as a
	                    legacy alias of /archive/:date so older links still resolve
	- `/leaderboard`    Daily / Streaks / All-time boards
	- `/archive`        the grid of past days
	- `/archive/:date`  replay a past day in PRACTICE mode (the date prop makes
	                    Daily dispatch game.load(date), which sets practice = true)
	- `/curate`         the admin curation tool (Task 12.1 creates the screen);
	                    lazy-imported so the build only needs it once navigated,
	                    and guarded to admins (non-admins redirect to /)
	- `/auth/callback`  the OIDC return — Callback completes account.complete()
	                    then routes back to where sign-in began

	History mode matches tally (service/router.js).
*/
const routes = [
	{
		path: '/',
		name: 'today',
		component: Daily
	},
	{
		// legacy alias of /archive/:date — replay a past day, unranked
		path: '/play/:date',
		name: 'play',
		component: Daily,
		props: true
	},
	{
		path: '/leaderboard',
		name: 'leaderboard',
		component: Leaderboard
	},
	{
		path: '/archive',
		name: 'archive',
		component: Archive
	},
	{
		// a past date drives unranked practice; the date param is passed through
		// as the `date` prop so Daily's game.load(date) runs in practice mode
		path: '/archive/:date',
		name: 'practice',
		component: Daily,
		props: true
	},
	{
		// the admin curation tool. Task 12.1 creates @/screens/Curate.vue; the
		// lazy import keeps the rest of the build green until that file lands and
		// this route is navigated to.
		path: '/curate',
		name: 'curate',
		component: () => import('@/screens/Curate.vue'),
		beforeEnter: function(to, from, next) {

			// the session is recognised asynchronously on boot; wait for it
			// before deciding, so a direct load of /curate doesn't bounce out
			// before admin status is known
			var decide = function() {

				if (store.getters['account/isAdmin']) next()
				else next('/')

			}

			if (store.getters['account/checked']) decide()
			else store.dispatch('account/recognise').then(decide)

		}
	},
	{
		path: '/auth/callback',
		name: 'callback',
		component: Callback
	}
]

export default new VueRouter({

	mode: 'history',
	base: process.env.BASE_URL,
	routes

})
